import { useTranslation } from 'next-i18next'
import { useTracking } from '~/providers/tracking-provider'
import { useUserContext } from '~/providers/user-provider'
import { DashboardCard } from './dashboard-card'

export const DashboardFavsCard = () => {
	const { t } = useTranslation()
	const { track } = useTracking()
	const { userQuery } = useUserContext()

	return (
		<DashboardCard
			isLoading={userQuery.isLoading}
			title={t('cwDashboard:favs.title') as string}
			link={{
				label: t('cwDashboard:favs.linkLabel'),
				href: '/favorites',
				onClick: () => track.click('dashboard-seeFavorites-link'),
			}}
			childrenClassName='text-6xl font-bold leading-none text-primary'
		>
			{userQuery.data?.favorites?.length || 0}
		</DashboardCard>
	)
}
